import { AtlasPolygon } from '../../mu-atlas/interfaces/mu-atlas-polygon.interface';
import { AtlasPolygonOptions, AtlasPosition } from '../../mu-atlas/interfaces/mu-atlas-types.interface';

declare var L;

export class MuMapLeafletPolygon implements AtlasPolygon {
  private data: any;
  private polygon: any;

  constructor(options: AtlasPolygonOptions) {
    this.polygon = L.polygon(options.paths);
    this.polygon.setStyle({
      color: options.strokeColor,
      opacity: options.strokeOpacity,
      weight: options.strokeWeight,
      fillColor: options.fillColor,
      fillOpacity: options.fillOpacity,
    });
  }

  getPath(): AtlasPosition[] {
    return this.polygon.getLatLngs()[0];
  }

  setValues(value: any): void {
    this.data = value;
  }

  get(key: string): any {
    return this.data?.[key];
  }

  getElementForMap(): any {
    return this.polygon;
  }
}
